<template>
  <div id="interactive" :class="appClass">
	<div id="quiz">
	  <img src="./assets/header.svg" alt="">
	  <h1 ref="quizTitle" tabindex="-1" role="text">Screen time for kids 5 &amp; under</h1>
	  
<transition name="fade">
	  <!-- Intro -->
	  <div 
		v-if="showIntro" 
		class="slide-intro"
	  >
	  <p tabindex="-1" role="text">Too much time in front of screens—phones, tablets, computers and TVs—can hurt children's language, social, cognitive and motor skills development.</p>
	  <p tabindex="-1" role="text">Learn how much screen time is OK for kids from birth through age 5. Plus get tips on how to grow your child's skills without screens in play.</p>
	  <button 
		class="quiz-button" 
		type="button"
		@click="startQuiz"
		>
		Begin 
		<span aria-hidden="true">›</span>
	  </button>
	</div><!-- .slide-intro -->
</transition>

<transition name="fade">
	<!-- Results -->
	<div 
	  v-if="showResultsScreen" 
	  class="slide-result"
	  :class="selectedAnswer.labelClass"
	>
	  <div v-html="selectedAnswer.result" ref="answerResult" tabindex="-1" role="text"></div>
	  <div 
		class="button-container" 
		v-show="selectedAnswer.moreInfo"
	  >
		<button 
		  class="quiz-button" 
		  type="button"
		  @click="showMoreInfo"
		>
		  {{ selectedAnswer.moreInfoText }}
		  <span aria-hidden="true">›</span>
		</button>
	  </div>

	  <div 
		class="button-container" 
		v-show="selectedAnswer.nextQuestion"
	  >
		<button 
		  class="quiz-button" 
		  type="button"
		  @click="nextQuestion"
		>
		  Next question 
		  <span aria-hidden="true">›</span>
		</button>
	  </div>
	  
	  <button @click="showCurrentQuestion" class="quiz-back"><span aria-hidden="true">‹ </span>Back</button>
	  <button 
		class="quiz-reset" 
		type="button"
		v-show="!selectedAnswer.nextQuestion" 
		@click="startOver"
	  >
		Start over
	  </button>

	</div><!-- .slide-result -->
</transition>

<transition name="fade">
	<!-- More info -->
	<div 
	  v-if="showMoreInfoScreen" 
	  class="slide-more-info"
	  :class="selectedAnswer.labelClass"
	>
	  <div v-html="selectedAnswer.moreInfo" ref="moreInfo"></div>
	  <button @click="showResults" class="quiz-back"><span aria-hidden="true">‹ </span>Back</button>
		<button 
			class="quiz-reset" 
			type="button"
			v-show="!selectedAnswer.nextQuestion" 
			@click="startOver"
		>
			Start over
		</button>

	</div><!-- .slide-more-info -->
</transition>

<transition name="fade">
	<!-- Questions -->
	<div 
	  v-if="showQuestion" 
	  class="slide-question"
	  :class="currentQuestion.labelClass"
	>
		<div class="color">
			<fieldset>
				<legend ref="questionFieldset" tabindex="-1" role="text" v-html="currentQuestion.text"></legend>
				<div 
				v-for="(answer, i) in currentQuestion.answers" 
				:key="answer.text" 
				@click="answerChosen(answer)"
				>
				<label 
				class="quiz-button  quiz-button--radio" 
				:class="[{selected: isSelected(i), unselected: isntSelected(i)}, answer.labelClass]" 
				:for="'q' + currentIndex + 'a' + i" 
				>
					<input 
					type="radio" 
					:id="'q' + currentIndex + 'a' + i" 
					:name="'q' + currentIndex" 
					:value="'answer' + i" 
					v-model="selectedRadio"
					>
					<div v-if="answer.image" class="quiz-button__image" :style="{ backgroundImage: `url(${require(`./assets/${answer.image}`)})` }"></div>
					<div class="quiz-button__indicator"></div>
					<div class="quiz-button__text" v-html="answer.text"></div>
				</label>
				</div>
			</fieldset>
		</div>

	  <div 
		class="button-container" 
		v-show="selectedAnswer"
	  >
		<button 
		class="quiz-button" 
		type="button"
		@click="answerQuestion()"
		>
		  Next 
		  <span aria-hidden="true">›</span>
		</button>
	  </div>

	  <button 
			class="quiz-reset" 
			type="button"
			@click="startOver"
		>
			Start over
		</button>
	</div><!-- .slide-question -->
</transition>


	</div><!-- #quiz -->
  </div><!-- #app -->
</template>

<script>
import quizData from './data/quizData.json';

export default {
  name: 'app',
  components: {
  },
  data() {
	var scriptParams = ((document.getElementById('coffeyHumanaAssessment')) ? document.getElementById('coffeyHumanaAssessment').dataset : []);

	return {
	  quizData: quizData,
	  white: scriptParams.white == 'true' || scriptParams.white == '',
	  horizontal: scriptParams.horizontal == 'true' || scriptParams.horizontal == '',
	  //alternateText: scriptParams.alternate == 'true' || scriptParams.alternate == '',
	  currentIndex: 0,
	  selectedRadio: null,
	  showIntro: true,
	  showQuestion: false,
	  showResultsScreen: false,
	  showMoreInfoScreen: false,
	  resultMessage: null,
	  selectedAnswer: null
	}
  },
  methods: {
	startQuiz() {
	  this.showIntro = false;
	  this.showQuestion = true;

	  this.$nextTick(function(){
		this.$refs.questionFieldset.focus();
	  });
	},

	answerQuestion() {
	  
	  if (this.selectedAnswer.result != null) {
		this.showResults();
	  } else {
		this.nextQuestion();
	  }
	},

	answerChosen(answer) {
	  this.selectedAnswer = answer;
	},

	isSelected(i) {
	  if (this.selectedRadio === 'answer' + i) {
		return true;
	  }
	},

	isntSelected(i) {
	  if (this.selectedRadio != 'answer' + i && this.selectedRadio != null) {
		return true;
	  }
	},

	showCurrentQuestion(){
		this.showQuestion = true;
		this.showResultsScreen = false;
	},

	nextQuestion() {
	  this.selectedRadio = null;

	  if (this.selectedAnswer.nextQuestion != null) {
		this.currentIndex = this.selectedAnswer.nextQuestion;
		this.showResultsScreen = false;
		this.selectedAnswer = null;

		this.$nextTick(function(){
		  this.$refs.questionFieldset.focus();
		});
	  }
	},

	prevQuestion() {
	  if (!this.isFirstSlide) {
		this.currentIndex--;
	  }
	},

	showResults() {
	  this.showResultsScreen = true;
	  this.showQuestion = false;
	  this.showMoreInfoScreen = false;

	  this.$nextTick(function(){
		this.$refs.answerResult.focus();
	  });
	},

	showMoreInfo() {
	  this.showResultsScreen = false;
	  this.showMoreInfoScreen = true;

	  this.$nextTick(function(){
		this.$refs.moreInfo.focus();
	  });
	},

	startOver() {
	  this.currentIndex = 0;
	  this.selectedRadio = null;
	  this.selectedAnswer = null;
	  this.showQuestion = false;
	  this.showResultsScreen = false;
	  this.showMoreInfoScreen = false;
	  this.showIntro = true;

	  this.$nextTick(function(){
		this.$refs.quizTitle.focus();
	  });
	}
  },
  computed: {
	appClass() {
	  return {isWhite: this.white, isHorizontal: this.horizontal};
	},
	isLastSlide() {
	  return this.currentIndex === this.quizData.questions.length - 1;
	},

	isFirstSlide() {
	  return this.currentIndex === 0;
	},

	currentQuestion() {
	  if (this.alternateText) {
		return this.quizData.questionsAlt[this.currentIndex];
	  } else {
		return this.quizData.questions[this.currentIndex];
	  }
	}
  }
};
</script>

<style lang="scss">
  @import './scss/app.scss';
</style>
